export default function LogoMark({ size = 40, className = "" }) {
    return (
        <img
            src="/logo-mark.png"
            width={size}
            height={size}
            alt="Aryan Yoga logo"
            data-testid="logo-mark"
            className={`shrink-0 select-none rounded-full ${className}`}
            style={{ width: size, height: size }}
            draggable={false}
        />
    );
}
